export default __webpack_public_path__ + "locales/pt-BR/CreateEditRoomDialog.json?hash=0e2333bdb21fb4c51e891f65104d789c";